import React, { Component } from "react";

class DamageFeatureBox extends Component {
  render() {
    return (
      <div className="heading-bx">
        <h1 className="title mb-0 h3">
          ÅTERSTÄLL DIN BIL TILL SITT BÄSTA SKICK EFTER
          <br /> EN OLYCKA!
        </h1>
        <p className="pt-4">
          Olyckor kan hända, men vi på Kungälv Bilskadecenter är här för att göra processen smidig. Våra
          skadereparationstjänster täcker allt från mindre repor och bucklor till större strukturella skador. Vi arbetar
          med alla försäkringsbolag för att göra reparationen så enkel som möjligt för dig
        </p>
        <p>
          Med vårt erfarna team och toppmodern utrustning kan vi hantera alla typer av skador på din bil. Vi garanterar
          att ditt fordon återställs till sitt ursprungliga skick med högsta precision och kvalitet. Våra tjänster
          inkluderar även karosserireparation och plåtarbeten.
        </p>
        <p>
          Din säkerhet är vår prioritet. Boka en skadebesiktning hos oss idag och låt oss ta hand om din bil på bästa
          möjliga sätt.
        </p>
      </div>
    );
  }
}

export default DamageFeatureBox;
